<template>
    <b-navbar class="header" sticky="">
        <b-navbar-brand to="/dashboard">
            <img src="../../assets/logo.png" class="d-inline-block align-top" height="30" width="30" />
            WespiLift
        </b-navbar-brand>
        <b-navbar-nav style="margin: auto">
            <h5 class="appTitle">
                {{ appName }}
            </h5>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
            <div class="navbar-user">
                <span class="navbar-user-name">
                    {{ fullName }}
                </span>
                <span>
                    {{ role }}
                </span>
            </div>
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
                <template v-slot:button-content>
                    <img src="../../assets/user-placeholder.png" class="userAvatar" />
                </template>
                <b-dropdown-item @click="didTapChangePassword">
                    <font-awesome-icon class="fa-fw" icon="key" />&ensp;Change Password
                </b-dropdown-item>
                <b-dropdown-item v-if="role == 'Administrator'" @click="didTapUserManagement">
                    <font-awesome-icon class="fa-fw" icon="user" />&ensp;User Management
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item @click="didTapLogout">
                    <font-awesome-icon class="fa-fw" icon="sign-out-alt" />&ensp;Logout
                </b-dropdown-item>
            </b-dropdown>
            
        </b-navbar-nav>
        <!-- <b-tooltip target="menu" triggers="focus" variant="dark" placement="bottomleft">
            <b-button-group vertical>id="menu" tabindex="0"
                <b-btn variant="dark" class="rightAlign">Change Password&ensp;<font-awesome-icon icon="plus-circle" /></b-btn>
                <b-btn class="rightAlign">User Management</b-btn>
                <b-btn class="rightAlign">Log Out</b-btn>
            </b-button-group>
        </b-tooltip> -->
    </b-navbar>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            fullName: "",
            role: ""
        }
    },
    computed: {
        appName() {
            return this.$route.name
        }
    },
    methods: {

        didTapChangePassword() {
            this.$router.push("/management/change-password")
        },

        didTapUserManagement() {
            this.$router.push("/management/user")
        },

        didTapLogout() {

            this.$axios.post("/auth/logout")
            this.$axios.defaults.headers.common['Authorization'] = `Bearer `

            localStorage.removeItem("accessToken")
            localStorage.removeItem("fullName")
            localStorage.removeItem("role")
            this.$router.push("/login")

        }

    },
    created() {

        this.fullName = localStorage.getItem("fullName")
        this.role = localStorage.getItem("role")

    }
}
</script>

<style scoped>

    .dropdown >>> button {
        padding: 0 !important;
    }

    div:focus {
        outline: unset;
        border: unset;
    }

    .header {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
        border-bottom: none;
        display: flex;
        text-align: center;
    }

    .appTitle {
        margin: auto;
        font-weight: 600;
    }

    nav.navbar {
        background: white;
        padding: 15px 20px;
    }

    nav a.navbar-brand {
        position: absolute;
        left: 20px;
    }

    ul.navbar-nav.ml-auto {
        position: absolute;
        right: 20px;
        display: flex;
        align-items: center;
    }

    .userAvatar {
        height: 35px;
        width: 35px;
        border-radius: 50%;
        border: 1px solid rgb(196, 196, 196);
        outline: none;
    }

    .navbar-user {
        margin-right: 15px;
        text-align: right;
    }

    .navbar-user span {
        display: block;
        line-height: 1;
        font-size: 12px;
    }

    .navbar-user span.navbar-user-name {
        font-size: 15px;
        margin-bottom: 3px;
    }

</style>    